'use strict';

/**
 * plan Sampling Service
 */
module.service('planSamplingService', [ 'SamplingService', 'Restangular', '$q', function(SamplingService, Restangular, $q) {

    /*
     * ------------------------------------------------------------------------------
     * SERVICE FUNCTIONS
     * -------------------------------------------------------------------------------
     */
    var planSamplingResource = Restangular.all('plansampling');
    
    var ss = Object.create(SamplingService);
    
    ss.pruebasrefreshviews = function() {
		var deferred = $q.defer();
		var answer = new restResponse();
		planSamplingResource.customPUT(null, 'pruebasrefreshviews').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
    
    ss.getLinePlanSampling = function(idPlan) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one("/plansamplingstateflowaudit", idPlan).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
    
	ss.searchPlanSampling = function(filters) {
        var deferred = $q.defer();
        var answer = new restResponse();

        planSamplingResource.customGET('', filters).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };

    ss.searchPlanSamplingForUserClient = function(iduser, filters) {
        var deferred = $q.defer();
        var answer = new restResponse();

        planSamplingResource.customGET('searchforclientuser/' + iduser, filters).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.createPlanSampling = function(createModel) {
    	var deferred = $q.defer();
        var answer = new restResponse();

        planSamplingResource.post(createModel).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });

        return deferred.promise;
    };
    
    ss.updatePlanSampling = function(idPlan, updateModel) {
        var deferred = $q.defer();
        var answer = new restResponse();
        planSamplingResource.customPUT(updateModel, idPlan).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getPlanSampling = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',id).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getPlanSamplingForClientUser = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling/getForclientuser',id).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getPlanSamplingHome = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansamplinghome',id).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getPlanSamplingHomeForClientUser = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansamplinghome/forclientuser',id).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getPlanSamplingBasicInfo = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansamplingsimple',id).get().then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.searchPlanSamplingBasicInfo = function(filters) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.all('plansamplingsimple').customGET('',filters).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.getPlanSamplingProducts = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',id).customGET('products').then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.startPlanSampling = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',id).post('initiate', undefined).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    ss.clonePlanSampling = function(id, cloneModel) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',id).post('clone', cloneModel).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };

    ss.cancelPlanSampling = function(id) {
        var deferred = $q.defer();
        var answer = new restResponse();
        Restangular.one('plansampling',id).post('cancel', undefined).then(function(response) {
            answer.handleSuccessfullResponse(response, response.data);
            deferred.resolve(answer);
        }, function(response) {
            answer.handleErrorResponse(response, response.data);
            deferred.reject(answer);
        });
        return deferred.promise;
    };
    
    return ss;
}]);